import { Dialog, Text } from "@asayinc/component-library";
import { Stack } from "@mui/material";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useResendTabulationReportMutation } from "src/store/tabulation";
import { useCurrentUserQuery } from "src/store/user";

interface IResendTabulationReportDialogProps {
  isOpen: boolean;
  onClose: () => void;
  reportId: string;
}

export function ResendTabulationReportDialog({
  isOpen,
  onClose,
  reportId,
}: IResendTabulationReportDialogProps) {
  const { id: proxyId } = useParams() as { id: string };
  const [resendReport, { isLoading }] = useResendTabulationReportMutation();
  const { data: currentUser } = useCurrentUserQuery();

  const onSubmit = () => {
    resendReport({ proxyId, reportId })
      .unwrap()
      .then(() => {
        toast.success("Tabulation report resent successfully");
      })
      .catch((e) => {
        toast.error(e?.data?.message || "Failed to resend tabulation report");
      })
      .finally(() => {
        onClose();
      });
  };

  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
      fullWidth
      title="Resend Tabulation Report"
      buttonActions={[
        {
          label: "Cancel",
          onClick: onClose,
          variant: "secondary",
          size: "small",
        },
        {
          label: "Confirm",
          onClick: onSubmit,
          loading: isLoading,
          size: "small",
        },
      ]}
      content={
        <Stack gap={2}>
          <Text variant="body2">
            This tabulation report will be sent to{" "}
            <strong>{currentUser?.email}</strong>.
          </Text>
        </Stack>
      }
      ctaOrientation="horizontal"
    />
  );
}
